import React from 'react'
import { getMessage } from '../../../utils/index'

import './StatusContratoForm.scss'
import { Card } from 'primereact/card'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'
import LtsInputText from '../../../components/lottus/lts-input-text'
import utils from '../../../utils'
import _ from 'lodash'
import LtsDropdownTipoStatusContrato from '../../../components/lottus/lts-dropdown-tipo-status-contrato'

export const StatusContratoForm = (props) => {
  const record = props.record
  const messages = props.messages
  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card title={getMessage(messages, 'statuscontrato.label.titulo') + ' ' + record.oid || ''}>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsDropdownUnidade
                name={'unidade'}
                label={getMessage(messages, 'statuscontrato.label.unidade')}
                value={props.record.unidade}
                onChange={(e) => props.setField('unidade', e)}
                showOptionAll={true}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={record.descricao}
                onChange={(e) => props.setField('descricao', e)}
                name={'descricao'}
                label={getMessage(messages, 'statuscontrato.label.descricao')}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <span className="p-float-label">
                <LtsDropdownTipoStatusContrato
                  name={'tipo'}
                  label={utils.getMessage(messages, 'statuscontrato.label.tipo')}
                  value={_.get(record, 'tipo', null)}
                  onChange={(e) => props.setField('tipo', e)}
                  showOptionAll={false}
                />
              </span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
